import { render, staticRenderFns } from "./RequestAccountDisable.vue?vue&type=template&id=415afa71&scoped=true&"
import script from "./RequestAccountDisable.vue?vue&type=script&lang=js&"
export * from "./RequestAccountDisable.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccountDisable.vue?vue&type=style&index=0&id=415afa71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415afa71",
  null
  
)

export default component.exports